module.exports = __webpack_public_path__ + "img/18.edc1f6ab.jpg";